import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import DataOrcamentoTable from "../../components/data-budget-table.js/data-budget-tables";
import NewMiniDrawer from "../../components/navMenu/menu-nav"
import { cardIconSx, clientListThemeVars } from "../../theme/globalStyle/globalStyle";
import './budget-list.css';
require("firebase/auth");

function BudgetList(){

    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user)
   const canCreateBudget = user?.permissoes?.budget?.isCreate || user?.permissoes?.orcamento?.cadastrar;
    const [openFilters, setOpenFilters] = useState(false);
    const [cleanFilters, setCleanFilters] = useState(false);


     return(
         <>
             {
                 userLogado > 0 ?
                     <NewMiniDrawer divOpen={
                         <Box className="budget-list-page" sx={pageWrapperSx} style={clientListThemeVars}>
                             <Card sx={heroCardSx}>
                                 <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                                     <Box className="budget-list-hero">
                                         <Stack spacing={1} className="budget-list-hero-copy">
                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                 <Box sx={cardIconSx}>
                                                     <Inventory2OutlinedIcon sx={{ color: "#ffffff" }} />
                                                 </Box>
                                                 <Typography sx={heroTitleSx}>Orçamentos</Typography>
                                             </Box>
                                             <Typography sx={heroSubtitleSx}>
                                                 Consulte, filtre e mantenha os Orçamentos usados nas operacoes comerciais e de transporte.
                                             </Typography>
                                         </Stack>

                                         <Stack direction="row" spacing={1.5}>
                                             {canCreateBudget ? (
                                                 <Button
                                                     component={Link}
                                                     to="/budget"
                                                     variant="contained"
                                                     startIcon={<AddIcon />}
                                                     sx={primaryActionSx}
                                                 >
                                                     Novo Orçamento
                                                 </Button>
                                             ) : null}

                                             <Button
                                                 variant="outlined"
                                                 sx={secondaryActionSx}
                                                 onClick={() => setCleanFilters(!cleanFilters)}
                                             >
                                                 Limpar Filtros
                                             </Button>

                                             <Button
                                                 variant="contained"
                                                 sx={highlightActionSx}
                                                 onClick={() => setOpenFilters(!openFilters)}
                                             >
                                                 Filtros Salvos
                                             </Button>
                                         </Stack>
                                     </Box>
                                 </CardContent>
                             </Card>

                             <Card sx={contentCardSx}>
                                 <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                                     <Box className="budget-list-table-heading">
                                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                             <Box sx={cardIconSx}>
                                                 <TableRowsOutlinedIcon sx={{ color: "#ffffff" }} />
                                             </Box>
                                             <Box>
                                                 <Typography sx={sectionTitleSx}>Lista de orçamentos</Typography>
                                                 <Typography sx={sectionSubtitleSx}>Use os filtros das colunas para localizar registros especificos.</Typography>
                                             </Box>
                                         </Box>
                                     </Box>
 
                                     <Box className="budget-list-table-shell">
                                         <DataOrcamentoTable
                                             cleanFilter={cleanFilters}
                                             openFilter={openFilters}
                                             onCleanFilterHandled={() => setCleanFilters(false)}
                                             onOpenFilterHandled={() => setOpenFilters(false)}
                                         />
                                     </Box>
                                 </CardContent>
                             </Card>
                         </Box>
                 }/>
                 :
                 <Navigate to='/login' />
             }
         </>
     );
 }
 
const pageWrapperSx = {
    p: { xs: 2, md: 3 },
    display: "flex",
    flexDirection: "column",
    gap: 2,
};


const secondaryActionSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  minHeight: 40,
  px: 2,
  whiteSpace: "nowrap",
  color: "var(--client-primary)",
  borderColor: "var(--client-primary-border)",
  "&:hover": {
    borderColor: "var(--client-primary)",
    backgroundColor: "var(--client-primary-soft)",
  },
};

const highlightActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    backgroundColor: "var(--client-highlight)",
    minHeight: 40,
    px: 2,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: "#e02c00",
    },
};

const heroCardSx = {
    borderRadius: "18px",
    border: "1px solid var(--client-primary-border)",
    boxShadow: "var(--client-shadow-soft)",
};

const heroTitleSx = {
    color: "var(--client-primary)",
    fontWeight: 700,
    fontSize: "1.25rem",
};

const heroSubtitleSx = {
    color: "rgba(1, 36, 67, 0.74)",
    fontSize: "0.92rem",
    lineHeight: 1.5,
    maxWidth: 760,
};

const primaryActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    backgroundColor: "var(--client-primary)",
    minHeight: 40,
    px: 2,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: "var(--client-primary-hover)",
    },
};

const contentCardSx = {
    borderRadius: "var(--client-radius-lg)",
    border: "1px solid var(--client-primary-border)",
    boxShadow: "var(--client-shadow-table)",
    background: "var(--client-surface-soft)",
};

const sectionTitleSx = {
    color: "var(--client-primary)",
    fontWeight: 700,
    fontSize: "1.05rem",
};

const sectionSubtitleSx = {
    color: "rgba(1, 36, 67, 0.62)",
    fontSize: "0.79rem",
    lineHeight: 1.45,
};

 export default BudgetList;
 
 




